import { instance, errorService } from '@/services/api'
import _ from 'lodash'
import { projectAPIs } from '@/services/authConstantsV1'
import AcquisitionAnalysisSheet from '@/components/DynamicComponents/Projects/Navigation/AnalysisSheet/Acquisition'
import NewConstructionAnalysisSheet from '@/components/DynamicComponents/Projects/Navigation/AnalysisSheet/NewConstruction'

export default {
  props: [
    'child',
    'projectData',
    'screenIndentifier',
    'dropdownData',
    'projectModule',
    'type',
    'columnSettings',
  ],
  components: {
    'acq-analysis-sheet': AcquisitionAnalysisSheet,
    'new-const-analysis-sheet': NewConstructionAnalysisSheet,
  },
  data() {
    return {
      assetsData: [],
      loader: true,
      visible: false,
      drawerHeight: null,
      visibleDrawer: false,
      title: 'Loading data...',
      activeKey: '1',
    }
  },
  mounted() {
    this.getAssetsDetails()
    this.$root.$off('addLevel')
    this.$root.$off('orderingTiles')
    this.$root.$off('onUpdateTakeoff')
    this.$root.$off('onCloneTakeoff')
    this.$root.$off('onDeleteTakeoff')
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    callback(key) {
      this.activeKey = key
    },

    getAssetsDetails() {
      this.loader = true
      instance
        .get(projectAPIs.project.asset.list(this.$route.params.id))
        .then(res => {
          this.assetsData = _.get(res.data, 'result', [])
          const asset = this.assetsData.some(i => i.analysisTypeId === 1)
          if (asset) {
            this.activeKey = '1'
          } else {
            this.activeKey = '2'
          }
          this.loader = false
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    updateColumnSettings(request) {
      this.$emit('updateColumnSettings', request)
    },
  },
}
